import {object} from './object.utils';


export const targetValue = (ev => object(ev.target).value);

export const targetFiles = (ev => object(ev.target).files);